// extracted by mini-css-extract-plugin
export default {"ui_kit_common":"styles_ui_kit_common__dGmrr","ui_kit_dialog":"styles_ui_kit_dialog__XFk4F"};